import RadiusFilter from './LocationFilter/RadiusFilter'
import RecommendedJobsFilter from './RecommendedJobsFilter'
import SectionFilter from './SectionFilter'

export const sectionFacetField = 'facilities.section_name'

const filters = [
  {
    filterName: 'Recommended Jobs',
    Component: RecommendedJobsFilter,
    requireLogin: true
  },
  {
    filterName: 'Radius',
    proximityOptions: [
      { text: '15 miles', value: 15 },
      { text: '25 miles', value: 25 },
      { text: '50 miles', value: 50 },
      { text: '75 miles', value: 75 },
      { text: '100 miles', value: 100 }
    ],
    Component: RadiusFilter
  },
  {
    filterName: 'Job Class',
    filterAttribute: 'applicant_group',
    showMore: false,
    sortOrder: [
      { label: 'PGA Professional Only' },
      { label: 'PGA Professional and General Public' },
      { label: 'PGA Golf Management University Internship' }
    ]
  },
  {
    filterName: 'Job Type',
    filterAttribute: 'employment_type',
    showMore: false
  },
  {
    filterName: 'Job Category',
    filterAttribute: 'job_category',
    showMoreLimit: 100
  },
  {
    filterName: 'Section',
    filterAttribute: sectionFacetField,
    Component: SectionFilter,
    showMoreLimit: 100
  }
]

export const FILTER_ATTRIBUTES = filters.map(({ filterAttribute }) => filterAttribute)

export default filters
